<template>
  <section id="stage">
    <v-carousel
      cycle
      :show-arrows="false"
      hide-delimiters
      interval="6000"
      :height="carouselHeight"
    >
      <v-carousel-item
        v-for="(item, i) in carousselItems"
        :key="i"
        class="carouselimg"
      >
        <v-img :src="item.src" :lazy-src="item.srcLazy" height="100%" eager />
      </v-carousel-item>
    </v-carousel>
  </section>
</template>

<script>
export default {
  data() {
    return {
      carousselItems: [
        { src: require("../../assets/stage/stage_orangenminze.jpg"),
          srcLazy: require("../../assets/stage/80/stage_orangenminze.jpg") },
        { src: require("../../assets/stage/stage_sonnenblume.jpg"),
          srcLazy: require("../../assets/stage/80/stage_sonnenblume.jpg") },
        { src: require("../../assets/stage/stage_drachenkopf2.jpg"),
         srcLazy: require("../../assets/stage/80/stage_drachenkopf2.jpg") },
        { src: require("../../assets/stage/stage_malve.jpg"),
          srcLazy: require("../../assets/stage/80/stage_malve.jpg") },
        { src: require("../../assets/stage/stage_spitzwegerich.jpg"),
          srcLazy: require("../../assets/stage/80/stage_spitzwegerich.jpg") }
      ]
    };
  },
  computed: {
    carouselHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 260;
        case "sm":
          return 260;
        default:
          return this.$vuetify.breakpoint.height / 1.7; //-400
      }
    }
  }
};
</script>

<style scoped>
.carouselimg {
  transition: 2.5s ease-in-out !important;
}
</style>
